import React from 'react'
import { Grid, GridProps } from '@material-ui/core'
import { isRtl } from '../../i18nInit'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: '1rem',
  },
  firstChild: {
    paddingRight: isRtl ? 0 : '10px',
    paddingLeft: isRtl ? '10px' : 0,
    flexShrink: 0,

    '& > h1': {
      marginBottom: '3px',
    },
  },
  secondChild: {
    overflow: 'hidden',
  },
  secondWrapper: {
    flexWrap: 'nowrap',
  },
  secondChildWithThird: { overflow: 'hidden', paddingRight: isRtl ? 0 : '10px', paddingLeft: isRtl ? '10px' : 0 },
  thirdChild: {
    flexShrink: 0,
  },
}))

const YumHeader = ({ children, ...props }: GridProps) => {
  const classes = useStyles()
  const childrenArr = React.Children.toArray(children)
  const firstChild = childrenArr[0]
  const secondChild = childrenArr[1]
  const thirdChild = childrenArr[2]
  return (
    <Grid
      container
      className={classes.root}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      wrap="nowrap"
      {...props}
    >
      {firstChild && (
        <Grid item className={classes.firstChild}>
          {firstChild}
        </Grid>
      )}
      {secondChild && (
        <Grid item className={classes.secondChild}>
          {!thirdChild ? (
            <>
              {secondChild}

              {thirdChild && (
                <Grid item className={classes.thirdChild}>
                  {thirdChild}
                </Grid>
              )}
            </>
          ) : (
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className={classes.secondWrapper}
            >
              <Grid item className={classes.secondChildWithThird}>
                {secondChild}
              </Grid>
              <Grid item className={classes.thirdChild}>
                {thirdChild}
              </Grid>
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  )
}

export default YumHeader
